import { render, staticRenderFns } from "./AddAdRevenue.vue?vue&type=template&id=357d4268&scoped=true&"
import script from "./AddAdRevenue.vue?vue&type=script&lang=js&"
export * from "./AddAdRevenue.vue?vue&type=script&lang=js&"
import style0 from "./AddAdRevenue.vue?vue&type=style&index=0&id=357d4268&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357d4268",
  null
  
)

export default component.exports